import Row from '@amzn/meridian/row';
import React from 'react';
import { useIntl } from 'react-intl';
import { Feature, isFeatureEnabled } from '../../../config/FeaturesConfig';
import CustomDate from '../Table/LighthouseMetrics/CustomDate';
import Page from '../../../Types/Page';
import BasicFilter from './BasicFilter';
import { FilterIdentity } from './Type/FilterType';
import { SDS_VERTICALS, convertToVerticalOption } from '../../../Util/Vertical';

interface LighthouseFiltersProps {
  verticalValue: string;
  weekValue: string;
  skillValue: string;
  channelValue: string;
  segmentValue: string;
  marketplaceValue: string;
  verticalOptions: string[];
  skillOptions: string[];
  channelOptions: string[];
  segmentOptions: string[];
  marketplaceOptions: string[];
  filterTruncate: any;
  weekOptions: string[];
  dateRange: any;
  customDate: any;
  setVerticalValue: any;
  setSkillValue: any;
  setChannelValue: any;
  weekValueChanger: any;
  setSegmentValue: any;
  setMarketplaceValue?: any;
  setCustomDate: any;
  setDateRange: any;
  page: string;
  ccxDetailsPage?: string;
}

const Filters: React.FC<LighthouseFiltersProps> = ({
  verticalValue,
  weekValue,
  skillValue,
  channelValue,
  segmentValue,
  verticalOptions,
  skillOptions,
  channelOptions,
  segmentOptions,
  weekOptions,
  customDate,
  dateRange,
  setVerticalValue,
  setSkillValue,
  setChannelValue,
  weekValueChanger,
  setSegmentValue,
  setCustomDate,
  setDateRange,
  page,
  ccxDetailsPage,
  marketplaceValue,
  marketplaceOptions,
  setMarketplaceValue,
}: LighthouseFiltersProps): React.ReactElement => {
  const intl = useIntl();

  // enable custom date range for team/proxy team page only
  const enableCustomDateRange =
    page === Page.TEAM && isFeatureEnabled(Feature.CUSTOM_DATE_RANGE);

  const isTrendFilter = page === Page.METRICS;

  const FilterGroups = (): React.ReactElement => {
    return (
      <>
        <BasicFilter
          label={intl.formatMessage({
            id: 'cs_perfportal_marketplace',
            defaultMessage: 'Marketplace',
          })}
          value={marketplaceValue}
          filterOptions={marketplaceOptions}
          setValue={setMarketplaceValue}
          identity={FilterIdentity.MARKETPLACE}
          page={page}
          ccxDetailsPage={ccxDetailsPage}
        />
        <BasicFilter
          label={intl.formatMessage({
            id: 'cs_perfportal_skill',
            defaultMessage: 'Skill',
          })}
          value={skillValue}
          filterOptions={skillOptions}
          setValue={setSkillValue}
          identity={FilterIdentity.SKILL}
          page={page}
          ccxDetailsPage={ccxDetailsPage}
        />
        <BasicFilter
          label={intl.formatMessage({
            id: 'cs_perfportal_channel',
            defaultMessage: 'Channel',
          })}
          value={channelValue}
          filterOptions={channelOptions}
          setValue={setChannelValue}
          identity={FilterIdentity.CHANNEL}
          page={page}
          ccxDetailsPage={ccxDetailsPage}
        />
        {SDS_VERTICALS.has(convertToVerticalOption(verticalValue)) && (
          <BasicFilter
            label={intl.formatMessage({
              id: 'cs_perfportal_segment',
              defaultMessage: 'Segment',
            })}
            value={segmentValue}
            filterOptions={segmentOptions}
            setValue={setSegmentValue}
            identity={FilterIdentity.SEGMENT}
            page={page}
            ccxDetailsPage={ccxDetailsPage}
          />
        )}
      </>
    );
  };

  return (
    <>
      <Row alignmentVertical='top' alignmentHorizontal='justify'>
        <BasicFilter
          label={intl.formatMessage({
            id: 'cs_perfportal_vertical',
            defaultMessage: 'Vertical',
          })}
          value={verticalValue}
          filterOptions={verticalOptions}
          setValue={setVerticalValue}
          identity={FilterIdentity.VERTICAL}
          page={page}
          ccxDetailsPage={ccxDetailsPage}
        />
        {!isTrendFilter && (
          <CustomDate
            enableCustomDateRange={enableCustomDateRange}
            customDate={customDate}
            dateRange={dateRange}
            weekValue={weekValue}
            weekOptions={weekOptions}
            page={page}
            setCustomDate={setCustomDate}
            setDateRange={setDateRange}
            weekValueChanger={weekValueChanger}
          />
        )}
        <FilterGroups />
      </Row>
    </>
  );
};

export default Filters;
